'use client';

import { TOKEN_KEY } from '@/constants/auth';
import { dispatchStorageEvent } from '@/hooks/useLocalStorage';

export const getJWT = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  return localStorage.getItem(TOKEN_KEY);
};

export const setJWT = (token: string): void => {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem(TOKEN_KEY, token);
  dispatchStorageEvent(TOKEN_KEY);
};

export const removeJWT = (): void => {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.removeItem(TOKEN_KEY);
  dispatchStorageEvent(TOKEN_KEY);
};
